import React from "react";
import ActionButton from "../component/Common/ActionButton";

const DeleteConfirmModal = ({
  open,
  onClose,
  onConfirm,
  message = "Are you sure you want to delete?",
  heading = "Confirm Delete",
  actionText = "Delete",
  loading = false,
  actionVariant = "cancel",
  zIndex = 1100,
  children = null,
}) => {
  if (!open) {
    return null;
  }

  return (
    <div className="modal" style={{ display: "block", zIndex }}>
      <div className="modal-content-cat_voucher6">
        {/* Header */}
        <div className="row">
          <div className="col-12 page_heading">
            <h4 className="text-center pt-2">{heading}</h4>
            <span className="close pr-2" onClick={onClose}>
              &times;
            </span>
          </div>
        </div>

        {/* Body */}
        <div className="row p-2" style={{ width: "100%" }}>
          <div className="col-12">
            <p style={{ fontSize: "16px" }}>{message}</p>
            {children}
          </div>

          {/* Buttons */}
          <div className="col-12">
            <div className="float-right mt-2">
              <ActionButton text="Cancel" variant="grey" type="button" onClick={onClose} />

              <ActionButton
                text={actionText}
                type="button"
                variant={actionVariant}
                onClick={onConfirm}
                disabled={loading}
                isLoading={loading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
